import React, { ReactNode, useMemo, useState } from "react";
import { services } from "../../../globals";
import { useSuppressedFilter } from "../../../state/FilterContext";
import { useSiteContext } from "../../../state/SiteContext";
import { TextExtractor, findFirstComponentOfType } from "../../internal/TextExtractor";

interface MarkdownExportUrlProps {
    children: ReactNode,
    suppress?: string,
}

/***
 * Value source that outputs the markdown export URL for a file path.
 */
export const MarkdownExportUrl = React.memo(function MarkdownExportUrl({
    children,
    suppress,
}: MarkdownExportUrlProps): React.ReactElement {
    const linkedState = useSuppressedFilter(suppress || "");
    const { siteState } = useSiteContext();
    const [pathValue, setPathValue] = useState("");
    const pathChild = useMemo(() => findFirstComponentOfType(children, "arg-path"), [children]);

    const url = pathValue
        ? services.file.getDirectLink(
            siteState.site?.name || "",
            pathValue,
            linkedState.validity || "",
            linkedState.systemProperties || {},
            linkedState.lang || "",
            "markdown",
        )
        : "";

    return <>
        {pathChild && (
            <TextExtractor onExtractedText={setPathValue}>
                {pathChild?.props.children}
            </TextExtractor>
        )}
        {url}
    </>;
});
